import { Button } from "@mui/material";
import styles from "./styles.module.css";

const MotorButtons = ({ versao, motoresMap, handleAnalisar, podeNavegarMotores = true }) => {
  const buttonsLeft = ["Sob Despesa", "Exclusões", "Monofásico"];
  const resumoScript = motoresMap["Resumo Geral"];
  
  // Verificar se tem resumo geral disponível (com valores salvos)
  const temResumoGeral = versao.scriptsDisponiveis?.has(resumoScript);
  const podeResumo = Boolean(temResumoGeral && podeNavegarMotores);

  return (
    <div className={styles.motoresContainer}>
      <div className={styles.motoresLeft}>
        {buttonsLeft.map((label) => {
          const script = motoresMap[label];
          const habilitado = versao.scriptsDisponiveis?.has(script);
          const podeClicar = Boolean(habilitado && podeNavegarMotores);
          return (
            <Button
              key={`${versao.idPreviaVersao}-${label}`}
              variant="contained"
              size="small"
              className={`${styles.btnMotor} ${!habilitado ? styles.btnSemTema : ''}`}
              onClick={() => {
                if (podeClicar) {
                  handleAnalisar(versao, script);
                }
              }}
              disabled={!podeClicar}
            >
              {label}
            </Button>
          );
        })}
      </div>
      <Button
        variant="contained"
        size="small"
        className={`${styles.btnMotorRight} ${!temResumoGeral ? styles.btnSemTema : ''}`}
        onClick={() => {
          if (podeResumo) {
            handleAnalisar(versao, resumoScript);
          }
        }}
        disabled={!podeResumo}
      >
        Resumo Geral
      </Button>
    </div>
  );
};

export default MotorButtons;

